import { render, staticRenderFns } from "./CardSacadorCedenteApresentante.vue?vue&type=template&id=234a2f20"
import script from "./CardSacadorCedenteApresentante.vue?vue&type=script&lang=js"
export * from "./CardSacadorCedenteApresentante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports